export default __webpack_public_path__ + "static/media/practice_right_bg.a9eba85d.png";